<template>
  <div>
    <TabPanel>
      <!-- 報告び -->
      <app-input-status
        label="報告日"
        :message="submissionDateError"
        :validationError="submissionDateError ? true : false"
        :success="submissionDate && !submissionDateError ? true : false"
      />
      <AppSentBackItem
        color="blue"
        :message="getSentBackItemMessage('submission_date')"
      />

      <app-date-input
        placeholder="報告日"
        v-model="submissionDate"
        name="submissionDate"
        color="blue"
      />
      <!-- 報告日  -->

      <!-- 活動項目種別 -->
      <app-input-status
        label="経費項目"
        class="mt-3"
        :validationError="selectedActionTypesError ? true : false"
        :message="selectedActionTypesError"
        :success="
          isActionSelected() && !selectedActionTypesError ? true : false
        "
      />
      <AppSentBackItem
        color="blue"
        :message="getSentBackItemMessage('action_types')"
      />

      <div class="flex flex-row items-center">
        <div
          class="mr-4"
          v-for="actionType in selectedActionTypes"
          :key="'request-form-action-type' + actionType.id"
        >
          <app-checkbox
            :ref="'actionType' + actionType.id"
            :explanation="actionType.name"
            :fieldId="String(actionType.id)"
            color="blue"
            v-model="actionType.hasAttribute"
            @click="switchCheckbox(actionType)"
          />
        </div>
      </div>
      <!-- 活動項目種別 -->

      <!-- 開始日 終了日 -->
      <div class="flex flex-row justify-between mt-3">
        <div class="flex flex-col w-1/2">
          <app-input-status
            label="開始日"
            :message="startDateError"
            :validationError="startDateError ? true : false"
            :success="startDate && !startDateError ? true : false"
          />
          <div class="flex flex-row" style="display:displayblock;">
            <AppSentBackItem
              color="blue"
              :message="getSentBackItemMessage('period')"
            />
          </div>
          <app-date-input
            placeholder="開始日"
            v-model="startDate"
            name="startDate"
            color="blue"
          />
        </div>
        <div class="flex">
          <span
            class="text-lg font-bold text-blue"
            style="align-items: flex-end; display: flex; padding-bottom: 8px; padding-right: 4px;"
            >～</span
          >
        </div>
        <div class="flex flex-col w-1/2">
          <app-input-status
            label="終了日"
            :message="endDateError"
            :validationError="endDateError ? true : false"
            :success="endDate && !endDateError ? true : false"
          />
          <AppSentBackItem
            color="blue"
            :message="getSentBackItemMessage('period')"
          />

          <app-date-input
            placeholder="終了日"
            v-model="endDate"
            name="endDate"
            color="blue"
          />
        </div>
      </div>
      <!-- 開始日 終了日 -->

      <!-- 参加者氏名 -->
      <app-input-status
        label="参加者氏名"
        class="mt-3"
        :message="memberNameError"
        :validationError="memberNameError ? true : false"
        :success="memberName && !memberNameError ? true : false"
      />
      <AppSentBackItem
        color="blue"
        :message="getSentBackItemMessage('member_name')"
      />
      <app-user-pull-down-list
        color="blue"
        placeholder="参加者を入力ください"
        :items="users"
        v-model="memberName"
        name="memberName"
      />
      <!-- 参加者氏名 -->
    </TabPanel>

    <TabPanel>
      <!-- 視察、研修、要望・陳情の場所 -->
      <app-input-status
        label="視察、研修、要望・陳情の場所"
        :message="placeError"
        :validationError="placeError ? true : false"
        :success="place && !placeError ? true : false"
      />
      <AppSentBackItem
        color="blue"
        :message="getSentBackItemMessage('place')"
      />
      <app-text-area
        color="blue"
        rows="6"
        placeholder="場所を入力ください"
        v-model="place"
        name="place"
      ></app-text-area>
      <!-- 視察、研修、要望・陳情の場所 -->

      <!-- 目的 -->
      <app-input-status
        label="目的"
        :message="purposeError"
        :validationError="purposeError ? true : false"
        :success="purpose && !purposeError ? true : false"
      />
      <AppSentBackItem
        color="blue"
        :message="getSentBackItemMessage('purpose')"
      />
      <app-text-area
        color="blue"
        rows="6"
        placeholder="目的を入力ください"
        v-model="purpose"
        name="purpose"
      ></app-text-area>
      <!-- 目的 -->
    </TabPanel>

    <TabPanel>
      <!-- 宿泊場所詳細［任意］ -->
      <app-input-status
        label="宿泊場所詳細 [任意]"
        :message="remarksError"
        :validationError="remarksError ? true : false"
        :success="remarks && !remarksError ? true : false"
      />
      <AppSentBackItem
        color="blue"
        :message="getSentBackItemMessage('remarks')"
      />

      <app-text-area
        id="remarks"
        v-model="remarks"
        color="blue"
        rows="15"
        name="remarks"
      ></app-text-area>
    </TabPanel>

    <TabPanel class="mr-5">
      <AppOfficeMessage color="blue" type="request"></AppOfficeMessage>
    </TabPanel>
  </div>
  <button
    id="request-validate-toda"
    style="display: none;"
    @click="requestSubmit()"
  ></button>
</template>

<script>
import { TabPanel } from '@headlessui/vue'
import { onMounted, ref } from 'vue'
import AppDateInput from '@/components/ui/AppDateInput'
import AppInputStatus from '@/components/ui/AppInputStatus'
import AppSentBackItem from '@/components/ui/AppSentBackItem'
import AppCheckbox from '@/components/ui/AppCheckbox'
import AppTextArea from '@/components/ui/AppTextArea'
import AppUserPullDownList from '@/components/ui/AppUserPullDownList'
import AppOfficeMessage from '@/components/ui/uiToda/AppOfficeMessageToda'
import { useRequestForm } from '@/services/politicalActionToda/useRequestForm'
import { useImgUploader } from '@/services/useImgUploader'
import { usePoliticalActions } from '@/services/politicalActionToda/usePoliticalActions'

export default {
  name: 'RequestForm_TODA',

  components: {
    TabPanel,
    AppInputStatus,
    AppSentBackItem,
    AppDateInput,
    AppCheckbox,
    AppTextArea,
    AppUserPullDownList,
    AppOfficeMessage,
  },

  setup() {
    const { imgUploader } = useImgUploader()
    const { currentPoliticalAction, users } = usePoliticalActions()
    const actionType1 = ref('')
    const actionType2 = ref('')
    const isActionSelected = () => {
      let ret = false
      for (
        let i = 0;
        i < currentPoliticalAction.selectedActionTypes.length;
        i++
      ) {
        if (
          currentPoliticalAction.selectedActionTypes[i].hasAttribute == true
        ) {
          ret = true
          break
        }
      }
      return ret
    }

    onMounted(() => {
      let images = []

      if (
        currentPoliticalAction.application.images.length == 1 &&
        currentPoliticalAction.application.images[0].normalImage == null
      ) {
        images = []
      } else {
        for (
          let i = 0;
          i < currentPoliticalAction.application.images.length;
          i++
        ) {
          currentPoliticalAction.application.images[i].blackImage != null
            ? images.push(
                currentPoliticalAction.application.images[i].blackImage,
              )
            : images.push(
                currentPoliticalAction.application.images[i].normalImage,
              )
        }
      }

      imgUploader.error = ''
      imgUploader.files = []
      imgUploader.dropped = 0
      imgUploader.imgs = images
    })

    const switchCheckbox = actionType => {
      if (
        actionType1.value.isChecked &&
        !actionType2.value.isChecked &&
        actionType.id === 2
      ) {
        return (
          (actionType1.value.isChecked = false),
          (currentPoliticalAction.selectedActionTypes[0].hasAttribute = false)
        )
      }
      if (
        !actionType1.value.isChecked &&
        actionType2.value.isChecked &&
        actionType.id === 1
      ) {
        return (
          (actionType2.value.isChecked = false),
          (currentPoliticalAction.selectedActionTypes[1].hasAttribute = false)
        )
      }
    }

    return {
      isActionSelected,
      ...useRequestForm(),
      switchCheckbox,
      actionType1,
      actionType2,
      users,
    }
  },
}
</script>
<style lang="scss"></style>
